import { PropTypes } from "prop-types";

function ToolTip({ children = "tooltip text" }) {
  return (
    <div className="tooltip">
      <p>{children}</p>
    </div>
  );
}

ToolTip.PropTypes = {
  children: PropTypes.element
};

export default ToolTip;
